import { useState } from "react";
import { Loader2 } from "lucide-react";
import { api, apiError } from "../../lib/api";

const inp = "w-full border border-[#15202B]/15 bg-white px-3 py-2.5 outline-none focus:border-[#15202B] text-[15px]";

export const PasswordForm = () => {
  const [f, setF] = useState({ current: "", new: "", confirm: "" });
  const [busy, setBusy] = useState(false); const [msg, setMsg] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault(); setMsg(null);
    if (f.new.length < 8) return setMsg({ err: true, t: "Le nouveau mot de passe doit contenir au moins 8 caractères." });
    if (f.new !== f.confirm) return setMsg({ err: true, t: "Les deux nouveaux mots de passe ne sont pas identiques." });
    setBusy(true);
    try { await api.post("/auth/change-password", { current: f.current, new: f.new }); setF({ current: "", new: "", confirm: "" }); setMsg({ t: "Mot de passe changé. Utilisez-le à votre prochaine connexion." }); }
    catch (ex) { setMsg({ err: true, t: apiError(ex) }); } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="bg-white p-5 sm:p-6 shadow-sm grid gap-4 max-w-md" data-testid="password-form">
      <h2 className="f-display text-2xl">Changer mon mot de passe</h2>
      {[["current", "Mot de passe actuel", "current-password"], ["new", "Nouveau mot de passe (8 caractères minimum)", "new-password"], ["confirm", "Confirmer le nouveau mot de passe", "new-password"]].map(([k, l, ac]) => (
        <label key={k} className="grid gap-1.5 text-xs tracking-[0.12em] uppercase text-[#55636F]">{l}
          <input type="password" className={`${inp} normal-case tracking-normal`} value={f[k]} onChange={set(k)} autoComplete={ac} data-testid={`password-${k}`} />
        </label>
      ))}
      {msg && <p className={`text-sm ${msg.err ? "text-[#A2372F]" : "text-[#24502C]"}`} data-testid="password-message">{msg.t}</p>}
      <button className="btn-ink justify-self-start" disabled={busy} data-testid="password-submit">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Enregistrer"}</button>
    </form>
  );
};
